<template>
  <b-list-group id="account_dir_list">
    <b-list-group-item v-for="account in list"
                       v-bind:key="account.id"
                       class="col-6 account_dir_list_item"
                       v-bind:class="$mq"
                       style="overflow-wrap: break-word">
      <AccountLink v-bind:account="account.id"
                   style="font-size: unset;"
                   v-bind:shorten="$mq == 'sm'" />
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import AccountLink from '../AccountLink.vue'

export default {
  name: 'AccountDirList',

  props : {
    list : Array
  },

  components : {
    AccountLink
  },

  methods : {
    account_link : function(account){
      return { path : 'account/' + account.id };
    }
  }
}
</script>

<style scoped>
#account_dir_list {
  flex-direction: row;
  flex-wrap: wrap;

  margin-bottom: 10px;
}

.account_dir_list_item.sm,
.account_dir_list_item.md{
  padding: 5px;
}
</style>
